import { Stack, styled as muiStyled } from '@mui/material';

interface ContainerProps {
  useOrder?: boolean;
}
export const Container = muiStyled(Stack)<ContainerProps>(({ useOrder }) => ({
  cursor: useOrder ? 'pointer' : 'default',
}));
